import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match, RouteComponentProps } from "react-router";
import { createSelectorRx, search, nullsafe, assertUnreachable, first } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import * as globals from "app/resources/globals";
import { EntregaRealizadaFormRx } from "./form";



const state = globals.state.map(x => x.viajeApp!);

/**Vista de una entrega realizada */
export class EntregaIndex extends React.PureComponent<RouteComponentProps<{ id: string }>> {
    render() {
        return <EntregaRealizadaFormRx
            value={state}
            claveEntrega={this.props.match.params.id}
            onChange={x => globals.setState({ viajeApp: x })}
        />
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajeapp/entrega/index.tsx